import { useState, useEffect } from 'react';

import { Pagination } from '@andes/pagination';

import { usePaginationList } from '../../providers/Pagination/src/PaginationListProvider';
import { useAppContext } from '../../providers/AppProvider';

interface PaginationListOfListsProps {
  page: string;
  profilePath: string;
}

const PaginationListOfLists = ({
  page: pageSelected,
  profilePath,
}: PaginationListOfListsProps) => {
  const { env, trackingId } = useAppContext();
  const { pageQuantity, isWebview } = usePaginationList();
  const [baseUrl, setBaseUrl] = useState('');
  const [redirect, setRedirect] = useState('');
  const safePageSelected = Number(pageSelected) || 1;

  useEffect(() => {
    if (trackingId) {
      if (typeof window !== 'undefined') {
        setBaseUrl(window.location.origin);
      }

      const initialRedirect = `${baseUrl}/social/${profilePath}/lists?page=$pageNumber${
        env ? `&env=${env}` : ''
      }`;

      setRedirect(`${initialRedirect}#tracking_id=${trackingId}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackingId]);

  if (isWebview || pageQuantity <= 1) {
    return null;
  }

  const formatUrl = (href: any, page: any) => href.replace('$pageNumber', page);

  return (
    <div className="aff-social-pagination__container">
      <Pagination
        formatUrl={formatUrl}
        pageQuantity={pageQuantity}
        pageSelected={safePageSelected}
        href={redirect}
      />
    </div>
  );
};

export default PaginationListOfLists;
